export const SET_EMAIL = 'app/ForgotPassword/SET_EMAIL'
export const RESET_PASSWORD_DONE = 'app/ForgotPassword/RESET_PASSWORD_DONE'
export const RESET_PASSWORD_ERROR = 'app/ForgotPassword/RESET_PASSWORD_ERROR'
export const RESET_PASSWORD = 'app/ForgotPassword/RESET_PASSWORD'
export const EMAIL_NOT_VALID = 'app/ForgotPassword/EMAIL_NOT_VALID'
